import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

//import './css/index.css';
//import './css/header.css';

export default class SupportServices extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			services: [],
			servers: [],
			test: [],
		};
		this.serviceMove = this.serviceMove.bind(this);
		this.serviceTest = this.serviceTest.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		await this.getServices();
		//console.log(x.data);

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		console.log(x.data);
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

	}

	componentWillUnmount() {
	}

	async getServices() {
		let params = new URLSearchParams();
		const x = await postApi('/v3/support/services', params);
		console.log(x.data);
		this.setState({services: [], servers: [], test: []},()=>{
			this.setState({status: true, services: x.data.services || [], servers: x.data.servers || [], test: x.data.test || []});
		});
	}


	async serviceMove(service, server) {
		if( window.confirm("Are you sure you wish to move this service?") ) {
			let params = new URLSearchParams();
			params.append('service', service);
			params.append('server', server);
			await putApi('/v3/support/servicesmove', params);
			await this.getServices();
		}
	}


	async serviceTest(service, status) {
		if( window.confirm("Are you sure you wish to test/remove this service?") ) {
			let params = new URLSearchParams();
			params.append('service', service);
			params.append('status', status);
			await putApi('/v3/support/servicestest', params);
			await this.getServices();
		}
	}
	

	render() {
		console.log(this.state.servers);
		
		const test = this.state.test.map((e,i) => {
			return (
				<tr key={i} className="border-bottom">
					<td><span className="text-decoration-underline text-primary">#{e.id}</span></td>
					<td>
						<div className="d-flex align-items-center">
							<div className="avatar avatar-md me-2 avatar-rounded lh-1">
								
							</div>
							<div className="lh-1">
								<a href="https://laravelui.spruko.com/velvet/product-details">{e.uid}</a>
								<p className="fs-11 text-muted mb-0 mt-1">Test Server</p>
							</div>
						</div>
					</td>
					<td>{moment(e.ctime).format("DD/MM/YYYY HH:mm:ss")}</td>
					<td className="text-center">03</td>
					<td></td>
					<td> $13.800</td>
					<td>
						<div className="mt-sm-1 d-block">
							
							<span className="badge bg-danger-transparent text-danger"></span>
						</div>
					</td>
					<td>
						<Dropdown>
							<Dropdown.Toggle variant="success" id="dropdown-basic" size="sm">
								Action
							</Dropdown.Toggle>

							<Dropdown.Menu>
								<Dropdown.Item disabled={true}><del>Activate</del></Dropdown.Item>
								<Dropdown.Item disabled={true}><del>Terminate</del></Dropdown.Item>
								<Dropdown.Divider />
								<Dropdown.Item disabled={true}>Move To Server</Dropdown.Item>

								

								
								<Dropdown.Divider />
								<Dropdown.Item onClick={()=>this.serviceTest(e.id, 0)}>Remove from Test Server</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</td>
				</tr>
			)
		});
		const services = this.state.services.map((e,i) => {
			/*let trafficin = Math.floor((e.inbytes / e.download*100));
			let trafficout = Math.floor((e.outbytes / e.upload*100));
			let memory = Math.floor((e.memused / e.memtotal*100));
			let hdd = Math.floor((e.hddused / e.hddsize*100));
			console.log(e.inbytes / e.download*100);*/
			return (
				<tr key={i} className="border-bottom">
					<td><span className="text-decoration-underline text-primary">#{e.id}</span></td>
					<td>
						<div className="d-flex align-items-center">
							<div className="avatar avatar-md me-2 avatar-rounded lh-1">
								<img src={`https://cloud.ultrastream.io/images/${e.avatar}`} alt="avatar" />
							</div>
							<div className="lh-1">
								<a href="https://laravelui.spruko.com/velvet/product-details">{e.title}</a>
								<p className="fs-11 text-muted mb-0 mt-1">{e.product}</p>
							</div>
						</div>
					</td>
					<td>{e.subdomain}</td>
					<td className="text-center">03</td>
					<td>{moment(e.mtime).format("DD/MM/YYYY HH:mm:ss")}</td>
					<td> $13.800</td>
					<td>
						<div className="mt-sm-1 d-block">
							{e.status === 0 &&<span className="badge bg-danger-transparent text-danger">Cancelled</span>}
							{e.status === 1 &&<span className="badge bg-success-transparent text-success">Active</span>}
							<span className="badge bg-danger-transparent text-danger"></span>
						</div>
					</td>
					<td>
						<Dropdown>
							<Dropdown.Toggle variant="success" id="dropdown-basic" size="sm">
								Action
							</Dropdown.Toggle>

							<Dropdown.Menu>
								<Dropdown.Item><del>Activate</del></Dropdown.Item>
								<Dropdown.Item><del>Terminate</del></Dropdown.Item>
								<Dropdown.Divider />
								<Dropdown.Item disabled={true}>Move To Server</Dropdown.Item>

								{(() => {
									return this.state.servers.map((f,j) => {
										return (
											<Dropdown.Item key={j} onClick={()=>this.serviceMove(e.id, f.id)} disabled={e.server===f.id}>{f.subdomain}</Dropdown.Item>
										)
									})
								})()}

								
								<Dropdown.Divider />
								<Dropdown.Item onClick={()=>this.serviceTest(e.id, 1)} disabled={e.server===1}>Run Server on Test Server</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</td>
				</tr>
			)
		});
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									
									<Col xs={12}>
										<div className="row row-cols-xxl-5 row-cols-xl-3 row-cols-md-2">
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Sales</p>
																<h3 className="mb-0">$18,645</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-primary-transparent ms-auto">
																<i className="bi bi-cart-check fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-primary-transparent rounded-pill">+24% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Revenue</p>
																<h3 className="mb-0">$34,876</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-secondary-transparent ms-auto">
																<i className="bi bi-archive fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+0.26% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Total Products</p>
																<h3 className="mb-0">26,231</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-info-transparent ms-auto">
																<i className="bi bi-handbag fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+06% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Expenses</p>
																<h3 className="mb-0">$73,579</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-warning-transparent ms-auto">
																<i className="bi bi-currency-dollar fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+10% <i className="fe fe-arrow-up"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Active Subscribers</p>
																<h3 className="mb-0">1,468</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-danger-transparent ms-auto">
																<i className="bi bi-bell fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+16% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									

									<Col xs={12}>
										<div className="card custom-card">
											<div className="card-header">
												<div>
													<h5 className="card-title mb-0">Critical Reports</h5>
												</div>
												<div className="ms-auto">
													<a aria-label="anchor" href="javascript:void(0)" className="btn btn-outline-light btn-icons btn-sm text-muted" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
														<i className="fe fe-more-vertical"></i>
													</a>
													<div className="dropdown-menu dropdown-menu-start">
														<a className="d-flex dropdown-item border-bottom" href="javascript:void(0)">
															<i className="ri-share-forward-line me-2"></i>Share
														</a>
														<a className="d-flex dropdown-item border-bottom" href="javascript:void(0)">
															<i className="ri-download-2-line me-2"></i>Download
														</a>
														<a className="d-flex dropdown-item" href="javascript:void(0)">
															<i className="ri-delete-bin-7-line me-2"></i>Delete
														</a>
													</div>
												</div>
											</div>
											<div className="card-body">
												<div className="table-responsive">
													<table className="table text-nowrap table-hover border table-bordered">
														<thead className="border-top">
															<tr>
																<th scope="row" className="border-bottom-0 text-center">S.NO</th>
																<th scope="row" className="border-bottom-0">Customer Name</th>
																<th scope="row" className="border-bottom-0">Server</th>
																<th scope="row" className="border-bottom-0">Order ID</th>
																<th scope="row" className="border-bottom-0">Order Date</th>
																<th scope="row" className="border-bottom-0">Price</th>
																<th scope="row" className="border-bottom-0">Status</th>
																<th scope="row" className="border-bottom-0">Action</th>
															</tr>
														</thead>
														<tbody>
															{test}
															{services}
															<tr className="border-bottom">
																<td className="text-center">01</td>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																			<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/1.jpg" alt="avatar" />
																		</div>
																		<div className="lh-1">
																			<a href="https://laravelui.spruko.com/velvet/product-details">Patty Furniture</a>
																			<p className="text-muted fs-11 mb-0 mt-1">patty@spruko.com</p>
																		</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP90</span></td>
																<td>01 Apr 2022</td>
																<td> $73.800</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-success-transparent text-success">Delivered</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="text-center">02</td>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																			<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/2.jpg" alt="avatar" />
																		</div>
																		<div className="lh-1">
																			<a href="https://laravelui.spruko.com/velvet/product-details">Allie Grate</a>
																			<p className="fs-11 text-muted mb-0 mt-1">allie@spruko.com</p>
																		</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP91</span></td>
																<td>02 Apr 2022</td>
																<td> $73.800</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-success-transparent text-success">Delivered</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="text-center">03</td>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																			<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/3.jpg" alt="avatar" />
																		</div>
																		<div className="lh-1">
																			<a href="https://laravelui.spruko.com/velvet/product-details">Peg Legge</a>
																			<p className="fs-11 text-muted mb-0 mt-1">peg@spruko.com</p>
																		</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP92</span></td>
																<td>24 Mar 2022</td>
																<td> $13.800</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-danger-transparent text-danger">Cancelled</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="text-center">04</td>
																<td>
																	<div className="d-flex align-items-center">
																		<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																			<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/4.jpg" alt="avatar" />
																		</div>
																	<div className="lh-1">
																		<a href="https://laravelui.spruko.com/velvet/product-details">Maureen Biologist</a>
																		<p className="fs-11 text-muted mb-0 mt-1">maureen@spruko.com</p>
																	</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP93</span></td>
																<td>22 Mar 2022</td>
																<td> $14.600</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-info-transparent text-info">Pending</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
															<tr className="border-bottom">
																<td className="text-center">05</td>
																<td>
																	<div className="d-flex align-items-center">
																	<div className="avatar avatar-md me-2 avatar-rounded lh-1">
																		<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/5.jpg" alt="avatar" />
																	</div>
																		<div className="lh-1">
																			<a href="https://laravelui.spruko.com/velvet/product-details">Olive Yew</a>
																			<p className="text-muted mb-0 mt-1 fs-11">olive@spruko.com</p>
																		</div>
																	</div>
																</td>
																<td><span className="text-decoration-underline text-primary">#123SP94</span></td>
																<td>20 Mar 2022</td>
																<td> $74.965</td>
																<td>
																	<div className="mt-sm-1 d-block">
																		<span className="badge bg-warning-transparent text-warning">Shipped</span>
																	</div>
																</td>
																<td>
																	<div className="g-2">
																		<a aria-label="anchor" className="btn  btn-primary-light btn-sm" data-bs-toggle="tooltip" data-bs-original-title="Edit">
																			<span className="ri-pencil-line fs-14"></span>
																		</a>
																		<a aria-label="anchor" className="btn btn-danger-light btn-sm ms-2" data-bs-toggle="tooltip" data-bs-original-title="Delete">
																			<span className="ri-delete-bin-7-line fs-14"></span>
																		</a>
																	</div>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</Col>
									
								</Row>
							</div>

							

							{/*
							<Row>
								<Col xl={6}>
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Services
											</div>
										</div>
									</div>
								</Col>

							</Row>
							<div className="row">
								<div className="col-xl-6">
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Default alerts
											</div>
										</div>
										<div className="card-body">
											<div className="alert alert-primary" role="alert">
													A simple primary alert—check it out!
											</div>
											<div className="alert alert-secondary" role="alert">
												A simple secondary alert—check it out!
											</div>
											<div className="alert alert-success" role="alert">
												A simple success alert—check it out!
											</div>
											<div className="alert alert-danger" role="alert">
												A simple danger alert—check it out!
											</div>
											<div className="alert alert-warning" role="alert">
												A simple warning alert—check it out!
											</div>
											<div className="alert alert-info" role="alert">
												A simple info alert—check it out!
											</div>
											<div className="alert alert-light" role="alert">
												A simple light alert—check it out!
											</div>
											<div className="alert alert-dark" role="alert">
												A simple dark alert—check it out!
											</div>
										</div>
									</div>
								</div>
							</div>
							*/}
						</div>
					</div>
				}
			</>
		);
	}
}
